export enum PBtnType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  OUTLINE = 'outline',
}

export enum PBtnSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
